export default __webpack_public_path__ + "static/media/mumbai.b1274e5b.png";